const isUndefinedOrNull = value => value === undefined || value === null;

export default isUndefinedOrNull;